import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "store/common/auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//projects
import projects from "./projects/reducer"

// Product Admin
import productAdminBirthChart from "store/ProductAdmin/birthChartReport/reducer"

// Product Admin - User Management
import astrolisting from "store/ProductAdmin/UserManagement/reducer"

//tasks
import tasks from "./tasks/reducer"

// Group - Reports
import grpReports from "store/group/reports/reducer"
import grpProfile from "store/group/profile/reducer"
import grp from "store/group/organisation/reducer"
import grpDashboard from "store/group/dashboard/reducer"
import payments from "store/payments/reducer"
import groupReport from "./auth/groupreport/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  projects,
  tasks,
  productAdminBirthChart,
  astrolisting,
  grpReports,
  grpProfile,
  grp,
  grpDashboard,
  payments,
  groupReport
})

export default rootReducer
